module.exports = __webpack_public_path__ + "img/login-splash.6e4719c4.jpg";